import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./style/theme/index.css";
import 'vant/lib/index.css'
import VideoPlayer from 'vue-video-player'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { NavBar, Tab, Tabs, DropdownMenu, DropdownItem, NoticeBar, Swipe, SwipeItem, Icon, Search, Popup, Tabbar, TabbarItem, Sidebar, SidebarItem, Pagination } from 'vant';

Vue.use(NavBar);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Pagination);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Popup);
Vue.use(Search);
Vue.use(Icon);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(NoticeBar);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VideoPlayer)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
